import React from "react";

type AnchorIconProps = {
    className?: string;
};

export const AnchorIcon: React.FC<AnchorIconProps> = ({className}) => {
    return (
        <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clip-path="url(#clip0_5349_999)">
                <path d="M21.6259 15.4375C21.6259 20.8203 17.1957 25.2504 11.8129 25.2504C6.43013 25.2504 2.01431 20.8387 2 15.4661" stroke="#FFF600" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M12 2.75L12 11.75" stroke="#FFF600" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M12 20.25C13.1046 20.25 14 19.3546 14 18.25C14 17.1454 13.1046 16.25 12 16.25C10.8954 16.25 10 17.1454 10 18.25C10 19.3546 10.8954 20.25 12 20.25Z" fill="#FFF600"/>
            </g>
            <defs>
                <clipPath id="clip0_5349_999">
                    <rect width="24" height="28" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}